import styled from "styled-components"

const AccountPage = styled.div`
    color:#448487;
    width:80vw;
    margin:0 auto;
    height:900px;
    text-align:center;
    padding:150px 0 20px 0;
`

export default AccountPage